const hr = {
	pages: {
		login: {
			title: "Prijava u sustav",
			username: "Korisničko ime",
			password: "Lozinka",
			signIn: "Prijava",
			validation: {
				usernameRequired: "Unesite korisničko ime za prijavu!",
				passwordRequired: "Unesite lozinku!"
			},
			errors: {
				failedAttempt: "Upisali ste krivo korisničko ime ili lozinku!"
			}
		},
		logout: "Odjava",
		home: {
			title: "Početna"
		},
		reports: {
			downloadLink: "Preuzmi izvještaj",
			filter: "Filtriranje"
		},
		pageHeader: {
			title: "Statistike"
		},
		pageFooter: {
			contentRangeOfYears: "©{{createdYear}}-{{currentYear}} Centar za digitalizaciju d.o.o.",
			contentSingleYear: "©{{createdYear}} Centar za digitalizaciju d.o.o."
		},
		languagePicker: "Promijeni jezik",
		userProfile: {
			title: "Korisnički profil",
			changePassword: {
				title: "Promjena lozinka",
				oldPassword: "Stara lozinka",
				newPassword: "Nova lozinka",
				confirmNewPassword: "Potvrdi novu lozinku",
				validations: {
					newPasswordMinLength: "Minimalna duljina {{num}} znakova!",
					newPasswordConfirmed: "Nova lozinka i potvrđena lozinka moraju biti jednake!"
				}
			}
		},
		favorites: {
			title: "Favoriti"
		}
	},
	sections: {
		croatianOlympicCommittee: {
			title: "Kategorizacija",
			codebook: "Registri",
			sportsAssociations: "Sportski savezi",
			sportsAssociationData: "Savez",
			sports: "Sportovi",
			sportsBranches: "Grane sportova",
			ages: "Uzrasti",
			competitionTypes: "Vrste natjecanja",
			organizationTypes: "Vrste organizacija",
			categoryRequestStatuses: "Statusi zahtjeva",
			categoryRequestTypes: "Vrste zahtjeva",
			competitionKindEnum: {
				0: "Nepoznato",
				1: "I (natjecanje pojedinaca)",
				2: "E (natjecanje ekipa)",
				3: "P (natjecanje parova i posada)",
				4: "T (natjecanje ekipa s individualnim rezultatom)"
			},
			sportTypeEnum: {
				0: "O - Olimpijski",
				1: "N - Neolimpijski"
			},
			organizations: {
				title: "Organizacije",
				companyData: "Pravna osoba",
				organizationData: "Organizacija",
				nameHistoryData: "Promjene naziva",
				companyTitle: "Naziv subjekta",
				companyPersonalId: "OIB subjekta",
				companyContactData: "Kontakt podaci",
				companyAddresses: "Adrese",
				companyEmails: "E-pošta",
				companyPhoneNumbers: "Tel. brojevi",
				addCompany: "Dodaj pravnu osobu",
				editCompany: "Uredi pravnu osobu"
			},
			organizationNames: {
				title: "Promjene naziva organizacija"
			},
			athletes: {
				title: "Sportaši",
				personData: "Fizička osoba",
				athleteData: "Sportaš",
				personFirstName: "Ime",
				personLastName: "Prezime",
				personPersonalId: "OIB fizičke osobe",
				personDateOfBirth: "Datum rođenja",
				personContactData: "Kontakt podaci",
				personAddresses: "Adrese",
				personEmails: "E-pošta",
				personPhoneNumbers: "Tel. brojevi",
				addPerson: "Dodaj fizičku osobu",
				editPerson: "Uredi fizičku osobu",
				reports: {
					allCategories: "Izvještaj - sve kategorije",
					activeCategories: "Izvještaj - aktivne kategorije"
				}
			},
			categoryTypes: "Oznake kategorija",
			categories: {
				title: "Kategorije",
				categoryData: "Kategorija",
				competitionData: "Natjecanje",
				pleadingData: "Pismena",
				requestData: "Zahtjevi",
				createCategory: "Kreiraj kategoriju s rješenjem",
				reports: {
					summaryReport: {
						title: "Izvještaj o ostvarenim kategorijama po sportovima",
						shortTitle: "Izvještaj po sportovima",
						dateFrom: "Datum od",
						dateTill: "Datum do",
						sportIds: "Sportovi",
						selectedSports: "Odabrani sportovi"
					},
					generalReport: {
						title: "Kategorije - općeniti izvještaj",
						shortTitle: "Općeniti izvještaj",
						fileName: "Kategorije - izvještaj",
						reportOutputType: "Format izvještaja",
						active: "Samo aktivni",
						isAnnulled: "Poništeno",
						dateFrom: "Vrijedi od",
						dateTill: "Vrijedi do",
						resolutionDateFrom: "Datum rješenja od",
						resolutionDateTill: "Datum rješenja do",
						athleteIds: "Sportaši",
						organizationIds: "Organizacije",
						categoryTypeIds: "Oznake kategorija",
						sportIds: "Sportovi",
						athleteCityIds: "Mjesta (sportaš)",
						athleteCountyIds: "Županije (sportaš)",
						athleteCountryIds: "Države (sportaš)",
						organizationCityIds: "Mjesta (organizacija)",
						organizationCountyIds: "Županije (organizacija)",
						ageIds: "Uzrasti",
						competitionTypeIds: "Tipovi natjecanja",
						competitionKinds: "Vrste natjecanja",
						sportTypes: "Tipovi sporta",
						competitionDateFrom: "Datum natjecanja od",
						competitionDateTill: "Datum natjecanja do",
						selectedSports: "Odabrani sportovi",
						selectAthletes: "Odaberi sportaše",
						selectOrganizations: "Odaberi organizacije",
						selectCategoryTypes: "Odaberi oznake kat.",
						selectCities: "Odaberi gradove",
						selectCounties: "Odaberi županije",
						selectCountries: "Odaberi države",
						selectAges: "Odaberi uzraste",
						selectCompetitionTypes: "Odaberi tipove natjecanja",
						selectCompetitionKinds: "Odaberi vrste natjecanja",
						selectSportTypes: "Odaberi tipove sporta",
						reportOutputTypeEnum: {
							0: "XLSX",
							1: "CSV"
						}
					},
					cocWebReport: {
						titleXlsx: "Web izvještaj - XLSX",
						titleCsv: "Web izvještaj - CSV",
						fileName: "Kategorije - web izvještaj"
					},
					azvoReport: {
						titleXlsx: "AZVO izvještaj - XLSX",
						titleCsv: "AZVO izvještaj - CSV",
						fileName: "Kategorije - AZVO izvještaj"
					}
				}
			},
			categoryRequests: {
				title: "Zahtjevi",
				requestData: "Zahtjev",
				athleteData: "Sportaš",
				pleadingData: "Pismena",
				createRequest: "Zaprimi zahtjev",
				createResolution: "Kreiraj rješenje (bez kat.)"
			},
			categoryRequestForms: {
				title: "Obrasci",
				new: "Kategorizacija",
				clubChange: "Promjena kluba",
				extension: "Produljenje",
				all: "Svi",
				athleteData: "Osobni podaci sportaša",
				organizationData: "Podaci o sportskoj pripadnosti",
				competitionData: "Postignut rezultat",
				extensionData: "Rješenje o kategorizaciji",
				useCategoryRequestFormForm: {
					title: "Kreiraj zahtjev",
					requestFormNumber: "Broj obrasca",
					requestFormPersonName: "Ime i prezime",
					requestFormPersonPersonalId: "OIB",
					requestFormPersonBirthDate: "Datum rođenja",
					athleteId: "Odabir sportaša",
					athleteCode: "Ev. broj",
					athleteName: "Ime i prezime",
					athletePersonalId: "OIB",
					athleteBirthDate: "Datum rođenja",
					athleteDetails: "Podaci odabranog sportaša",
					newAthlete: "- novi sportaš -",
					files: "Datoteke",
					info: "Kreira se zahtjev iz obrasca, predmet i podnesak (uz ažuriranje podataka sportaša)",
					navigateToCategoryRequest: "Idi na zahtjev"
				}
			},
			validations: {
				sportsAssociationHigherLevelChildExists: "Nadređeni savez mora biti više razine od podređenih",
				categoryAnnullmentDateRequired: "Polje je obavezno!"
			}
		},
		incomingShipments: {
			title: "Ulazne pošiljke",
			type: "Ulazna pošiljka",
			regularIncomingShipments: {
				title: "Redovne",
				unclassified: "Neklasificirano",
				restricted: "Ograničeno",
				confidential: "Povjerljivo",
				secret: "Tajno",
				topSecret: "Vrlo tajno"
			},
			unopenedIncomingShipments: {
				title: "Neotvorene",
				businessPartner: "Poslovni partner",
				employee: "Zaposlenik",
				classificationLevel: "Oznaka tajnosti",
				inappropriateContent: "Neodgovarajuć sadržaj",
				damagedOrOpenedShipment: "Oštećena/otvorena pošiljka",
				valuableShipment: "Vrijednosna pošiljka",
				hazardousShipment: "Opasna pošiljka",
				wrongDelivery: "Pogrešno dostavljeno",
				forHeadOfPublicCompany: "Za čelnika JPT",
				forwardingToKeyEnum: {
					employee: "Zaposlenik",
					partner: "Poslovni partner"
				}
			},
			addSenderForm: {
				addPartner: "Dodaj partnera",
				addUnsortedContact: "Dodaj nesvrstani kontakt",
				publicCompaniesLabel: "Javno pravna tijela",
				companiesLabel: "Pravne osobe",
				peopleLabel: "Fizičke osobe"
			},
			recipientKeyEnum: {
				orgUnit: "Org. jedinica",
				employee: "Zaposlenik",
				partner: "Poslovni partner"
			},
			senderKeyEnum: {
				partner: "Poslovni partner",
				employee: "Zaposlenik",
				unsorted: "Nesvrstani kontakt"
			},
			deliveryTypeEnum: {
				0: "Osobno",
				1: "Pošta",
				2: "Preporučena pošta",
				3: "Pošta s povratnicom",
				4: "Dostavna služba",
				5: "E-pošta",
				6: "eDelivery"
			}
		},
		outgoingShipments: {
			title: "Izlazne pošiljke",
			outgoingShipments: {
				title: "Pošiljke",
				editEmailRowButtonText: "Uredi email"
			},
			ePK: {
				title: "e-PK",
				generateEpkFileDialogButton: "Generiraj e-PK",
				stepper: {
					initialData: {
						title: "Inicijalni podaci",
						selectCodePlaceholder: "Pronađite odredišni poštanski ured"
					},
					parcelData: {
						title: "Podaci o pošiljkama",
						selectParcelIndication: "Potrebno je odabrati pošiljku",
						parcelDeliveryTypeNotSupport: "Način dostave nije podržan"
					},
					result: {
						title: "Generirana e-PK",
						successMessage: "e-PK uspješno generiran!",
						errorMessage: "Došlo je do greške, e-PK nije generiran!"
					}
				},
				configuration: {
					title: "Konfiguracija"
				},
				files: {
					title: "Epk datoteke",
					updateShipmentStatusTitle: "Promjena statusa pošiljki",
					updateShipmentStatusSubtitle: `Status pošiljki će biti promijenjen samo ako je novi status "Poslano"`,
					updateShipmentStatusButtonText: `Promijeni status pošiljki`,
					updateShipmentStatusConfirmationText: `Status pošiljki će biti promijenjen u "Poslano". Želite li nastaviti?`,
					updateShipmentStatusToRejectedConfirmationText: "Status pošiljki će ostati nepromijenjen. Želite li nastaviti?",
					uploadRefNumberRowButtonText: "Postavi referentni broj",
					uploadedRefSuccess: "Referentni broj uspješno postavljen!",
					statusesChangedSucces: "Statusi uspješno promijenjeni!"
				}
			},
			createEmailForm: {
				title: "Brzo kreiranje e-mailova",
				info: "E-mail se kreira samo za pošiljku koja ima način dostave e-pošta, postavljen e-mail predložak i za koju nije prethodno stvoren e-mail",
				status: {
					skipped: "Nije kreiran e-mail",
					created: "E-mail je stvoren i status ažuriran"
				}
			},
			outgoingShipmentUpdateForm: {
				title: "Ažuriranje statusa slanja",
				sendDate: "Datum slanja",
				outgoingShipmentStatusId: "Status",
				selectShipmentStatus: "Odaberi status"
			},
			confirmShipmentReceiptForm: {
				title: "Potvrda primitka pošiljke",
				receiptDate: "Datum primitka",
				buttonText: "Potvrdi primitak"
			},
			admissionBookReportForm: {
				titleShort: "Prijamna knjiga",
				title: "Ispis prijamne knjige",
				sendDate: "Datum slanja",
				usedDeliveryTypes: "Načini dostave",
				postalOffice: "Poštanski ured"
			},
			pleadingDispatches: {
				title: "Otpreme",
				defaultAddText: "Otprema pismena",
				dispatchCaseText: "Otprema predmeta",
				dispatchCaseControl: {
					selectCaseLabel: "Predmet",
					selectCasePlaceholder: "Odaberite predmet",
					pleadingTypesLabel: "Tipovi pismena",
					pleadingTypesPlaceholder: "Odaberite tipove pismena",
					deliveryTypesLabel: "Načini dostave",
					deliveryTypesPlaceholder: "Odaberite načine dostave",
					sendDateLabel: "Datum slanja",
					recipientsTypeLabel: "Vrsta primatelja",
					recipientsTypePlaceholder: "Odaberite vrstu primatelja",
					partnersLabel: "Dodatni primatelji",
					partnersPlaceholder: "Odaberite primatelje",
					dispatchButtonText: "Otpremi",
					atLeastOnePartnerRequired: "Potrebno je odabrati barem jednog primatelja"
				},
				createOutgoingShipmentWizard: {
					title: "Kreiraj izlaznu pošiljku",
					selectPleadingDispatchesStep: {
						title: "Odabira otpremi",
						pleadingDispatchTableTitle: "Pregled odabranih otprema",
						pleadingAttachmentTableTitle: "Pregled priloga"
					},
					setOutgoingShipmentDataStep: {
						title: "Unos podataka pošiljke"
					},
					createOutgoingShipmentStep: {
						title: "Potvrda kreiranja pošiljke"
					},
					createOutgoingShipmentDeliveryTemplateEditStep: {
						title: "Uredi dostavni predložak",
						shipmentCreatedTitle: "Pošiljka uspješno kreirana!",
						goToShipmentButtonText: "Idi na kreiranu pošiljku",
						editSaveTemplateButtonText: "Uredi i spremi email za slanje",
						email: {
							title: "Uredi email predložak"
						}
					}
				},
				createPleadingDispatchesForm: {
					title: "Brzo kreiranje otprema",
					pleadingId: "Pismeno",
					selectPleadings: "Odaberi pismeno",
					deliveryTypes: "Način slanja",
					selectDeliveryTypes: "Odaberi način slanja",
					emailTemplateId: "Email predložak",
					selectEmailTemplate: "Odaberi email predložak",
					sendDate: "Datum slanja",
					partnerIds: "Primatelji",
					selectPartners: "Odaberi primatelje",
					selectPartnerTypes: "Odaberi tip primatelja",
					selectAll: "Svi primatelji",
					selectMainOnly: "Glavni primatelj",
					selectOthersOnly: "Ostali primatelji",
					selectParty: "Stranka",
					selectLegalRepresentative: "Pravni zastupnik",
					selectAdditionalPartners: "Dodatni primatelji",
					createdSuccessMessage: "Uspješno kreirano {{count}} otpremi!",
					createdWarningMessage: "Nijedna otprema nije kreirana!",
					info: "Otprema će biti kreirana ukoliko postoje .pdf prilozi i odgovarajući kontakt za način dostave"
				},
				createOutgoingShipmentForm: {
					title: "Brzo kreiranje pošiljki",
					pleadingDispatchIds: "Otpreme",
					selectPleadingDispatches: "Odaberi otpreme",
					documentTypesForDeliveryType: "Tip dokumenta za način dostave",
					selectDocumentType: "Odaberi tip dokumenta",
					sendDate: "Datum slanja",
					outgoingShipmentStatusId: "Status",
					selectShipmentStatus: "Odaberi status",
					groupByRecipient: "Grupiraj po adresi primatelja"
				}
			},
			emailTemplates: {
				title: "E-mail predlošci"
			}
		},
		invoices: {
			title: "Računi",
			invoiceAttachments: {
				title: "Prilozi"
			}
		},
		publicAdministration: {
			title: "Predmeti",
			invalidate: "Storniraj",
			assign: "Dodijeli",
			assignmentSuccessfulMessage: "{{value}} uspješno dodijeljen!",
			administrativeProceedingInfo: "Podaci za upravni postupak",
			cases: {
				title: "Popis predmeta",
				type: "Predmet",
				openingDate: "Datum otvaranja predmeta",
				closingDate: "Datum zatvaranja predmeta",
				fileReferenceNumber: "Referentni broj",
				confirmInvalidate: "Predmet će biti storniran, želite li nastaviti?",
				invalidateCaseSuccess: "Predmet {{case}} uspješno storniran!",
				invalidateCaseError: "Došlo je do greške, predmet {{case}} nije storniran!",
				setInProgressButtonText: "Postavi status U Radu",
				confirmSetInProgress: "Status predmeta će biti postavljen u U Radu, želite li nastaviti?",
				confirmSetInProgressSuccess: "Status U Radu uspješno postavljen",
				confirmSetInProgressError: "Došlo je do greške prilikom postavljanja statusa U Radu",
				setIssuedForInspectionButtonText: "Postavi status Izdan na Uvid",
				confirmSetIssuedForInspection: "Status predmeta će biti postavljen u Izdan na Uvid, želite li nastaviti?",
				confirmSetIssuedForInspectionSuccess: "Status Izdan na Uvid uspješno postavljen",
				confirmSetIssuedForInspectionError: "Došlo je do greške prilikom postavljanja statusa Izdan na Uvid",
				setReturnedToArchiveButtonText: "Vrati u arhivu",
				confirmSetReturnedToArchive: "Status predmeta će biti postavljen u Arhiviran, želite li nastaviti?",
				confirmSetReturnedToArchiveSuccess: "Predmet je uspješno vraćen u arhivu",
				confirmSetReturnedToArchiveError: "Došlo je do greške prilikom vraćanja predmeta u arhivu",
				returnFromArchiveButtonText: "Vrati iz arhive",
				confirmReturnFromArchive: "Predmet će biti vraćen iz arhive, želite li nastaviti?",
				confirmSetReturnedFromArchiveSuccess: "Predmet uspješno vraćen iz arhive",
				confirmSetReturnedFromArchiveError: "Došlo je do greške prilikom vraćanja predmeta iz arhive",
				extractFromSystemButtonText: "Izluči",
				confirmExtractFromSystem: "Predmet će biti izlučen, želite li nastaviti?",
				confirmExtractFromSystemSuccess: "Predmet uspješno izlučen!",
				confirmExtractFromSystemError: "Došlo je do greške, predmet nije izlučen!",
				heldIndefinitely: "Trajno čuvanje",
				caseNotes: "Službene bilješke",
				caseAudit: "Povijest izmjena",
				auditExportFileName: "povijest-izmjena-za-predmet",
				archiveData: {
					title: "Arhivski zapisi"
				},
				caseStatusEnum: {
					open: "Otvoren",
					cancelled: "Storniran",
					closed: "Zatvoren",
					inProgress: "U obradi",
					archived: "Arhiviran",
					issuedForInspection: "Izdan na uvid"
				},
				gridExportBaseFileName: "PredmetiGridExport",
				caseResolutionFilterEnum: {
					1: "Svi",
					2: "Riješeni",
					3: "Neriješeni"
				}
			},
			acts: {
				title: "Akti",
				type: "Akt",
				invalidate: "Storniraj",
				confirmInvalidate: "Akt će biti storniran, želite li nastaviti?",
				invalidateActSuccess: "Akt {{value}} uspješno storniran!",
				invalidateActError: "Došlo je do greške, akt {{value}} nije storniran!",
				pleadingDispatches: "Otpreme",
				actAudit: "Povijest izmjena",
				auditExportFileName: "povijest-izmjena-za-akt",
				validations: {
					sendToPartnerIncludedInOtherPartners: "Primatelj ne može biti naveden u ostalim primateljima!"
				},
				gridExportBaseFileName: "AktiGridExport"
			},
			internalActs: {
				title: "Interni akti",
				type: "Interni akt",
				invalidate: "Storniraj",
				confirmInvalidate: "Interni akt će biti storniran, želite li nastaviti?",
				invalidateInternalActSuccess: "Interni akt {{value}} uspješno storniran!",
				invalidateInternalActError: "Došlo je do greške, interni akt {{value}} nije storniran!",
				internalActAudit: "Povijest izmjena",
				auditExportFileName: "povijest-izmjena-za-interni-akt",
				gridExportBaseFileName: "InterniAktiGridExport"
			},
			submissions: {
				title: "Podnesci",
				type: "Podnesak",
				invalidate: "Storniraj",
				confirmInvalidate: "Podnesak će biti storniran, želite li nastaviti?",
				invalidateSubmissionSuccess: "Podnesak {{value}} uspješno storniran!",
				invalidateSubmissionError: "Došlo je do greške, podnesak {{value}} nije storniran!",
				submissionAudit: "Povijest izmjena",
				auditExportFileName: "povijest-izmjena-za-podnesak",
				gridExportBaseFileName: "PodnesciGridExport"
			},
			pleadingAttachments: {
				title: "Prilozi pismena",
				fileContentName: "Datoteka",
				previewDocxButton: "Pregledaj dokument",
				overwriteCurrentFileButton: "Zamijeni s novim sadržajem",
				overwriteSuccess: "Datoteka uspješno zamijenjena",
				overwriteFailure: "Došlo je do greške prilikom zamjene datoteke",
				attachmentLockedEditButtonTooltip: "Za uređivanje priloga, potrebno ga je otključati.",
				editDocxButton: "Uredi dokument",
				confirmLock: "Jeste li sigurni da želite zaključati prilog?",
				confirmUnlock: "Jeste li sigurni da želite otključati prilog?",
				lockAttachmentFailure: "Došlo je do greške prilikom zaključavanja priloga",
				lockAttachmentSuccess: "Prilog uspješno zaključan",
				unlockAttachmentFailure: "Došlo je do greške prilikom otključavanja priloga",
				unlockAttachmentSuccess: "Prilog uspješno otključan",
				archiveName: "{{name}} - Prilozi",
				stickBarcode: "Zalijepi barkod",
				stickBarcodeSuccess: "Barkod uspješno zalijepljen!",
				stickBarcodeError: "Došlo je do greške, barkod nije zalijepljen!",
				convertToPdf: "Pretvori u PDF",
				convertToPdfWithBarcode: "Pretvori u PDF s barkodom",
				convertToPdfSuccess: "Datoteka uspješno pretvorena u PDF!",
				convertToPdfError: "Došlo je do greške, datoteka nije pretvorena u PDF",
				selectScanner: "Odaberi skener",
				scan: "Skeniraj",
				scanSuccess: "Dokument uspješno skeniran",
				scanError: "Došlo je do greške prilikom skeniranja dokumenta",
				selectScannerWarning: "Molimo odaberite skener",
				discoverScannersError: "Došlo je do greške prilikom otkrivanja skenera",
				discoveringScannersMessage: "Otkrivanje skenera...",
				noScannersFoundMessage: "Nije pronađen nijedan skener. Provjerite jesu li vaši skeneri povezani i uključeni.",
				availableScannersLabel: "Dostupni skeneri ({{count}}):",
				validateSignatures: "Validiraj potpise",
				validateSignaturesSuccess: "Potpisi uspješno validirani!",
				validateSignaturesError: "Došlo je do greške prilikom validacije potpisa"
			},
			pleadingNotes: {
				title: "Bilješke pismena"
			},
			pleadingStatuses: {
				0: "Korisnički status",
				1: "Otvoren",
				2: "Storniran",
				3: "Zatvoren",
				4: "U obradi",
				5: "Odobrenje zatraženo",
				6: "Odbijen",
				7: "Odobren",
				8: "Spremno za otpremu",
				9: "Otpremljeno",
				10: "Vraćeno iz otpreme"
			},
			dossiers: {
				title: "Dosjei"
			},
			pleadingApprovals: {
				title: "Odobrenja",
				changeStatusToInProgressButtonText: "Dodijeli status 'U obradi'",
				confirmStatusChange: "Status pismena će biti promijenjen u '{{pleadingStatus}}', želite li nastaviti?",
				confirmStatusChangeSuccessful: "Status pismena uspješno promijenjen u '{{pleadingStatus}}'!",
				confirmStatusChangeInProgress: "Status pismena će biti promijenjen u 'U obradi', želite li nastaviti?",
				confirmStatusChangeInProgressSuccessful: "Status pismena uspješno promijenjen!",
				approveButtonText: "Odobri",
				approvalApprovedMessage: "Pismeno odobreno!",
				rejectButtonText: "Odbij",
				approvalRejectedMessage: "Pismeno odbijeno!",
				requestApprovalButtonText: "Zatraži odobrenje",
				approvalRequestedMessage: "Odobrenje zatraženo",
				requestSignatureButtonText: "Zatraži potpis",
				signatureRequestedMessage: "Potpis zatražen",
				approvalReason: "Razlog",
				sentApprovalsTitle: "Poslani zahtjevi za odobrenje",
				emptySentApprovalsLabel: "Nema poslanih zahtjeva za odobrenje",
				refreshApprovalsListButtonTooltipText: "Osvježite listu odobrenja",
				receivedApprovalsTitle: "Primljeni zahtjevi za odobrenje",
				emptyReceivedApprovalsLabel: "Nema primljenih zahtjeva za odobrenje",
				noPleadingAttachments: "Nema nijednog priloga pismena"
			},
			proceedingTypeTransformation: {
				rowButtonText: "Pretvori u vrstu 'Upravni postupak'"
			}
		},
		businessPartners: {
			title: "Poslovni partneri",
			addresses: "Adrese",
			address: "Adresa",
			email: "E-pošta",
			phoneNumber: "Tel. broj",
			telNumbers: "Tel. brojevi",
			addTelNumber: "Dodaj tel. broj",
			addAddress: "Dodaj adresu",
			addEmail: "Dodaj email",
			citySelect: "Odaberite grad",
			main: "Glavna",
			publicCompanies: {
				title: "Javno pravna tijela",
				syncPublicCompaniesQuestion: "Jeste li sigurni da želite sinkronizirati sva javno pravna tijela?",
				synchronize: "Sinkroniziraj",
				syncSuccessful: "Uspješno sinkronizirano",
				syncError: "Došlo je do greške, javno pravna tijela nisu sinkronizirana!"
			},
			companies: {
				title: "Pravne osobe"
			},
			partnerBranchOffices: {
				title: "Poslovnice"
			},
			persons: {
				title: "Fizičke osobe"
			},
			unsortedContacts: {
				title: "Nesvrstani kontakti"
			},
			contacts: {
				phoneNumbers: {
					type: {
						0: "Kućni",
						1: "Mobitel"
					}
				}
			}
		},
		messages: {
			title: "Poruke",
			emails: {
				title: "E-pošta",
				sendAgain: "Ponovno pošalji",
				emailResent: "Email je ponovno poslan",
				useAttachmentDownloadLinkInfo: "Datoteke se ne dodaju kao prilozi već se preuzimaju putem generirane poveznice",
				missingDownloadLink: "Nedostaje poveznica za preuzimanje!",
				downloadAttachmentFinishedTitle: "Preuzimanje dovršeno",
				downloadAttachmentFinishedSubtitle: "Uspješno preuzeto, poveznicu više nije moguće iskoristiti",
				downloadAttachmentFileName: "Prilozi_{{value}}"
			}
		},
		documentTypes: {
			title: "Urudžbeni dokumenti",
			documentTypes: {
				title: "Vrste dokumenata"
			},
			documentTypeProperties: {
				name: "Naziv",
				isRequired: "Obavezno"
			},
			documentTypeData: {
				title: "Podaci dokumenta",
				selectDocumentType: "Odaberite tip dokumenta"
			},
			documentTypeTemplates: {
				title: "Predlošci dokumenta",
				selectDocumentType: "Odaberite tip dokumenta",
				fileNew: "Nova",
				fileExisting: "Postojeća",
				createFromTemplate: "Kreiraj iz predloška",
				createFromTemplateMessage: "Uspješno kreirano iz predloška!",
				createFromTemplateErrorMessage: "Došlo je do pogreške prilikom generiranja datoteke!",
				createDocument: "Stvori dokument",
				newDocumentName: "Naziv nove datoteke",
				template: "Predložak",
				printFromTemplate: "Ispiši iz predloška",
				printFromTemplateButton: "Ispiši",
				createFileFromTemplateForm: {
					title: "Odabir predloška",
					newDocumentName: "Naziv nove datoteke",
					templates: "Predlošci po tipu dokumenta",
					selectTemplate: "Odaberi predložak",
					requiredTemplate: "Barem jedan predložak mora biti odabran!"
				}
			},
			documentTypeTemplateProperties: {
				name: "Naziv",
				templatePlaceholder: "Tag",
				validations: {
					templatePlaceholderRequired: "Svi tagovi moraju biti uneseni!",
					templatePlaceholderUnique: "Svi tagovi moraju biti jedinstveni!"
				}
			},
			documentCollections: {
				title: "Mape",
				collections: {
					deleteSingleCollectionSuccess: "Mapa {{mapName}} je uspješno obrisana",
					deleteSingleCollectionError: "Došlo je do pogreške prilikom brisanja mape {{mapName}}, molimo pokušajte ponovno",
					deleteMultipleCollectionsSuccess: "Mape su uspješno obrisane!",
					deleteMultipleCollectionsError: "Došlo je do pogreške prilikom brisanja mapa, molimo pokušajte ponovno",
					deleteMultipleCollectionsConfirmation: `Jeste li sigurni da želite obrisati mape?`,
					createNewMapdrawerTitle: "Nova mapa",
					createNewMapButtonText: "Kreiraj novu mapu",
					createNewMapSuccess: "Mapa uspješno kreirana!"
				},
				documents: {
					createNewDocumentDrawerTitle: "Novi dokument",
					createNewDocumentButtonText: "Kreiraj novi dokument",
					createNewDocumentSuccess: "Dokument uspješno kreiran!",
					dragNDropMainText: "Dovucite i spustite PDF ili DOCX datoteku i kreirajte dokument",
					dragNDropWrongFileTypeText: "Dopušteno dodavanje samo PDF i DOCX datoteka!"
				},
				actionsMenu: {
					open_folder: "Otvori mapu",
					add_folder: "Dodaj mapu",
					edit_folder_name: "Uredi naziv mape",
					delete_folder: "Obriši mapu",
					download_document: "Preuzmi dokument",
					add_document: "Dodaj dokument",
					preview_document: "Pregledaj dokument",
					edit_document: "Uredi dokument",
					delete_document: "Obriši dokument"
				}
			}
		},
		administration: {
			title: "Administracija",
			users: {
				title: "Korisnici",
				confirmActivation: "Jeste li sigurni da želite aktivirati zaposlenika?",
				confirmDeactivation: "Jeste li sigurni da želite deaktivirati korisnika?",
				deactivateUserError: "Došlo je do greške prilikom deaktivacije korisnika",
				deactivateUserSuccess: "Korisnik uspješno deaktiviran",
				activateUserError: "Došlo je do greške prilikom aktivacije korisnika",
				activateUserSuccess: "Korisnik uspješno aktiviran"
			},
			passwordManagement: {
				title: "Promjena lozinke",
				changePassword: "Promijeni lozinku",
				changePasswords: "Promijeni lozinke",
				newPassword: "Nova lozinka",
				confirmNewPassword: "Potvrdi novu lozinku",
				confirmNewPasswords: "Potvrdi nove lozinke",
				confirmPasswordChange: "Jeste li sigurni da želite promijeniti lozinku?",
				confirmPasswordsChange: "Jeste li sigurni da želite promijeniti lozinke?",
				passwordChangeError: "Došlo je do greške prilikom promjene lozinke",
				passwordsChangeError: "Došlo je do greške prilikom promjene lozinki",
				passwordChangeSuccess: "Lozinka uspješno promijenjena",
				passwordsChangeSuccess: "Lozinke uspješno promijenjene",
				passwordTooShort: "Lozinka je prekratka",
				passwordsDoNotMatch: "Lozinke se ne poklapaju",
				userCount: "Broj odabranih korisnika: {{count}}",
				errorMessage: "Došlo je do pogreške, nikakve promjene nisu primijenjene!"
			},
			roles: {
				title: "Role",
				noPermissions: "Bez prava",
				editingRoleAccesControl: "Uređivanje kontrole pristupa za rolu ",
				addWholeGroup: "Dodaj cijelu grupu",
				addAllFromGroup: "Dodaj sve iz grupe",
				definingAccessControl: "Definiranje kontrole pristupa",
				addNewPermissions: "Automatski dodaj nova prava",
				addNewSubgroups: "Automatski dodaj nove podgrupe",
				addNewGroups: "Automatski dodaj nove grupe"
			},
			registryOffices: {
				title: "Pisarnice"
			},
			classification: {
				title: "Klasifikacija",
				classificationPlans: "Klasifikacijski planovi",
				classificationMarks: "Klasifikacijske oznake",
				administrativeRegionMainGroups: "Glavne grupe",
				administrativeRegionGroups: "Grupe",
				administrativeRegionSubGroups: "Podgrupe",
				classificationForms: "Klasifikacijski oblici",
				tradeClassifications: "Klasifikacija prema djelatnosti",
				senderClassificationMarkConfiguration: "Zadane klasifikacijske oznake za pošiljatelje"
			},
			systematization: {
				title: "Sistematizacija",
				branchOffices: "Poslovnice",
				workplaceSystematization: "Sistematizacija",
				organizationalUnits: "Organizacijske jedinice",
				workplaces: "Radna mjesta",
				workplaceEmployees: {
					title: "Zaposlenici",
					confirmActivation: "Jeste li sigurni da želite aktivirati zaposlenika?",
					activateEmployeeSuccess: "Zaposlenik uspješno aktiviran",
					activateEmployeeError: "Došlo je do greške prilikom aktivacije zaposlenika",
					confirmDeactivation: "Jeste li sigurni da želite deaktivirati zaposlenika?",
					deactivateEmployeeSuccess: "Zaposlenik uspješno deaktiviran",
					deactivateEmployeeError: "Došlo je do greške prilikom deaktivacije zaposlenika",
					confirmMarkAsZupUser: "Jeste li sigurni da želite označiti korisnika kao ZUP IT korisnika?",
					markAsZupUser: "Označi kao ZUP IT korisnika",
					markAsZupUserSuccess: "Korisnik uspješno označen kao ZUP IT korisnik",
					markAsZupUserError: "Došlo je do greške prilikom označivanja korisnika kao ZUP IT korisnika",
					confirmUnmarkAsZupUser: "Jeste li sigurni da želite odznačiti korisnika kao ZUP IT korisnika?",
					unmarkAsZupUser: "Odznači kao ZUP IT korisnika",
					unmarkAsZupUserSuccess: "Korisnik uspješno odznačen kao ZUP IT korisnik",
					unmarkAsZupUserError: "Došlo je do greške prilikom odznačivanja korisnika kao ZUP IT korisnika"
				},
				employeeGroups: {
					title: "Grupe zaposlenika"
				}
			},
			codebook: {
				title: "Šifrarnik",
				countries: "Države",
				counties: "Županije",
				cities: "Gradovi",
				caseStatuses: "Statusi predmeta",
				pleadingStatuses: "Statusi pismena",
				organizationalUnitTypes: "Tipovi organizacijskih jedinica",
				outgoingShipmentStatuses: "Statusi izlaznih pošiljki",
				incomingShipmentStatuses: "Statusi ulaznih pošiljki",
				documentCategories: "Kategorije dokumenata",
				pleadingCreatorMarks: "Oznake stvaratelja pismena",
				postalOffices: "Poštanski uredi"
			},
			customProperties: {
				title: "Dodatna polja",
				selectCustomPropertyEntity: "Odaberite entitet za dodatno polje",
				selectCustomPropertyType: "Odaberite tip dodatnog polja",
				selectRelationType: "Odaberite relaciju",
				selectTextType: "Odaberite vrstu teksta",
				selectDateType: "Odaberite vrstu datuma"
			}
		},
		businessProcessManagement: {
			title: "Upravljanje poslovnim procesima",
			wizardTitle: "Kreiraj automatski proces",
			buttonText: "Kreiraj proces",
			workflowType: {
				wizardStepTitle: "Odaberi vrstu procesa",
				workflowTypeLabel: "Vrsta procesa",
				workflowDescriptionLabel: "Opis procesa",
				workflowNameLabel: "Naziv procesa",
				workflowTypeEnum: {
					1: "Predmet",
					2: "Akt",
					3: "Interni akt",
					4: "Podnesak",
					5: "Ulazna pošiljka",
					6: "Dokument"
				},
				confirmEnable: "Jeste li sigurni da želite uključiti automatski proces?",
				confirmDisable: "Jeste li sigurni da želite isključiti automatski proces?",
				disableWorkflowError: "Došlo je do greške prilikom isključivanja automatskog procesa",
				disableWorkflowSuccess: "Automatski proces uspješno isključen",
				enableWorkflowError: "Došlo je do greške prilikom uključivanja automatskog procesa",
				enableWorkflowSuccess: "Automatski proces uspješno uključen"
			},
			workflowEvents: {
				cardTitle: "Događaj",
				wizardStepTitle: "Odaberi događaje i uvjete",
				selectEventLabel: "Odaberi vrstu događaja",
				createEventLabel: "Kreiraj događaj",
				selectConditionLabel: "Odaberi uvjet",
				incomingShipmentCreatedEvent: "Ulazna pošiljka kreirana",
				caseCreatedEvent: "Predmet kreiran",
				documentCreatedEvent: "Dokument kreiran",
				documentApprovedEvent: "Dokument odobren"
			},
			workflowSteps: {
				cardTitle: "Korak",
				wizardStepTitle: "Odaberite korake",
				createCaseStepLabel: "Kreiraj predmet",
				createSubmissionStepLabel: "Kreiraj podnesak",
				requestDocumentApprovalStepLabel: "Zatraži odobrenje dokumenta",
				setDocumentValidityDatesStepLabel: "Postavi rokove važenja",
				setDocumentStatusToReleasedStepLabel: "Postavi status dokumenta na 'Dostupan'"
			},
			workflowDefinitions: {
				modalTitle: "Detalji o kreiranom procesu",
				title: "Konfigurirani procesi",
				buttonText: "Prikaži"
			},
			initiatedWorkflows: {
				modalTitle: "Detalji o pokrenutom procesu",
				title: "Pokrenuti procesi",
				buttonText: "Prikaži",
				stepStatusEnum: {
					0: "U planu",
					1: "Trenutni korak",
					2: "Čeka na izvršavanje",
					3: "Čeka prethodni korak",
					4: "Uspješan",
					5: "Neuspješno",
					6: "Prethodni korak neuspjepšan"
				}
			}
		},
		zupIt: {
			administrativeAreas: "Upravna područja",
			administrativeJobs: "Upravni poslovi",
			administrativeMatters: "Upravne stvari",
			confirmationTypes: "Vrste potvrdi",
			legislations: "Zakoni",
			officialRecords: "Službene evidencije",
			pleadingStatuses: "Statusi pismena",
			branchOfficeConfiguration: {
				title: "Postavke za poslovnicu",
				endOfWork: "Kraj radnog vremena",
				saveZupItMethodologyConfirmationText: "Jeste li sigurni da želite spremiti ZUP IT metodologiju?",
				saveZupItCodebooksConfirmationText: "Jeste li sigurni da želite spremiti ZUP IT šifrarnike?",
				saveZupItMethodologyButtonText: "Spremi ZUP IT metodologiju",
				saveZupItCodebooksButtonText: "Spremi ZUP IT šifrarnike",
				startCertificationButtonText: "Pokreni certifikaciju",
				stopCertificationButtonText: "Završi certifikaciju",
				cancelCertificationButtonText: "Otkaži certifikaciju",
				runScenarioButtonText: "Pokreni scenarij Scenario1",
				startCertificationConfirmationText: "Jeste li sigurni da želite pokrenuti certifikaciju?",
				stopCertificationConfirmationText: "Jeste li sigurni da želite završiti certifikaciju?",
				cancelCertificationConfirmationText: "Jeste li sigurni da želite otkazati certifikaciju?",
				runScenarioConfirmationText: "Jeste li sigurni da želite pokrenuti scenarij: Scenario1?"
			},
			publicCompanies: {
				title: "Javno pravna tijela",
				setAsExecutingCompanySuccess: "Uspješno postavljeno zadano JPT",
				setAsExecutingCompanyError: "Greška prilikom postavljanja zadanog JPT",
				removeAsExecutingCompanySuccess: "Uspješno maknuto zadano JPT",
				removeAsExecutingCompanyError: "Greška prilikom micanja zadanog JPT",
				confirmRemovingExecutingCompany: "Jeste li sigurni da želite maknuti zadano JPT?",
				confirmSettingExecutingCompany: "Jeste li sigurni da želite postaviti zadano JPT?",
				set: "Postavi kao zadano JPT",
				unset: "Makni kao zadano JPT"
			},
			outboxMessages: "Izlazne poruke",
			users: "Korisnici"
		},
		finaInvoice: {
			tableTitle: "Popis zaprimljenih e-Računa",
			tableTooltip: "Odaberite jedan od e-Računa da se podaci automatski popune",
			invoiceId: "Br. rač.",
			supplierId: "Dobavljač",
			invoiceDate: "Datum",
			invoicePayableAmount: "Iznos [EUR]",
			invoiceStatus: "Status",
			showPdfTooltip: "Prikaži PDF",
			changeInvoiceStatus: "Promijeni status",
			changeInvoiceStatusPrompt: "Jeste li sigurni da želite promijeniti status?",
			changeInvoiceStatusSuccess: "Status računa uspješno promijenjen!",
			invoiceStatusEnumMap: {
				1: "Zaprimljen",
				2: "Zaprimanje potvrđeno",
				3: "Odobren",
				4: "Odbijen",
				5: "Plaćen",
				6: "Djelomično plaćen"
			}
		},
		applicationConfig: {
			title: "Postavke aplikacije",
			mailboxes: {
				title: "Poštanski sandučići",
				emailSuccessfullySentTo: "Email uspješno poslan na ",
				serverAddress: "Adresa servera",
				encryptionType: "Vrsta enkripcije",
				automaticallyReadEmails: "Automatsko čitanje mailova",
				lastReadDate: "Vrijeme zadnjeg čitanja",
				smtpSettings: "SMTP postavke",
				imapSettings: "IMAP postavke"
			},
			edeliveries: {
				title: "e-Delivery",
				configuration: {
					title: "Konfiguracija"
				}
			},
			deadlineConfiguration: {
				title: "Konfiguracija rokova rješavanja",
				proceedingType: {
					title: "Po vrsti postupka",
					minNumberOfDaysLabel: "Min. broj dana",
					maxNumberOfDaysLabel: "Maks. broj dana",
					defaultNumberOfDaysLabel: "Zadani broj dana"
				},
				submission: {
					title: "Za podneske"
				}
			},
			notificationsConfiguration: {
				title: "Notifikacije",
				notificationMarkedAsReadSuccess: "Obavijest označena kao pročitana",
				allNotificationsMarkedAsReadSuccess: "Sve obavijesti označene kao pročitane",
				employees: {
					title: "Zaposlenici"
				},
				priorities: {
					title: "Prioriteti"
				},
				types: {
					title: "Vrste",
					disableNotificationSuccess: "Notifikacija uspješno isključena",
					disableNotificationError: "Došlo je do greške prilikom isključivanja notifikacije",
					enableNotificationSuccess: "Notifikacija uspješno uključena",
					enableNotificationError: "Došlo je do greške prilikom uključivanja notifikacije",
					confirmEnable: "Jeste li sigurni da želite uključiti notifikaciju?",
					confirmDisable: "Jeste li sigurni da želite isključiti notifikaciju?"
				},
				notificationGroupEnum: {
					label: "Grupa notifikacija",
					1: "Predmet",
					2: "Akt",
					3: "Interni akt",
					4: "Podnesak",
					5: "Ulazna pošiljka",
					6: "Dokument"
				},
				notificationTypeEnum: {
					label: "Vrsta notifikacija",
					1: "Predmet kreiran",
					2: "Status predmeta promijenjen",
					3: "Predmet dodijeljen",
					4: "Predmet storniran",
					100: "Akt kreiran",
					101: "Status akta promijenjen",
					102: "Akt dodijeljen",
					103: "Akt storniran",
					104: "Približavanje roka rješavanja akta",
					105: "Akt odobren",
					106: "Odobrenje akta potvrđeno",
					107: "Odobrenje akta odbijeno",
					108: "Zatraženo odobrenje akta",
					109: "Akt je odbijen",
					200: "Interni akt kreiran",
					201: "Status internog akta promijenjen",
					202: "Interni akt dodijeljen",
					203: "Interni akt storniran",
					204: "Približavanje roka rješavanja internog akta",
					205: "Interni akt je odobren",
					206: "Odobrenje internog akta potvrđeno",
					207: "Odobrenje internog akta odbijeno",
					208: "Zatraženo odobrenje internog akta",
					209: "Interni akt je odbijen",
					300: "Podnesak kreiran",
					301: "Status podneska promijenjen",
					302: "Podnesak dodijeljen",
					303: "Podnesak storniran",
					304: "Približavanje roka rješavanja podneska",
					305: "Podnesak je odobren",
					306: "Odobrenje podneska potvrđeno",
					307: "Odobrenje podneska odbijeno",
					308: "Zatraženo odobrenje podneska",
					309: "Podnesak je odbijen",
					400: "Ulazna pošiljka kreirana",
					500: "Dokument dodijeljen",
					501: "Dokument odobren",
					502: "Odobrenje dokumenta potvrđeno",
					503: "Odobrenje dokumenta odbijeno",
					504: "Zatraženo odobrenje dokumenta",
					505: "Status dokumenta promijenjen",
					506: "Dokument odbijen",
					507: "Približavanje isteka dokumenta"
				},
				notificationChannelEnum: {
					1: "Početna stranica",
					2: "Email"
				},
				schedules: {
					add: "Dodaj raspored",
					remove: "Ukloni raspored"
				},
				referentPropertyPlaceholder: "Referentni datum",
				timeUnitPlaceholder: "Razdoblje od",
				timeUnitEnum: {
					placeholder: "Vrem. jedinica",
					1: "Sekundi",
					2: "Minuta",
					3: "Sati",
					4: "Dana"
				},
				relativeToDateEnum: {
					placeholder: "Prije/Poslije",
					1: "Prije datuma"
				},
				priorityEnum: {
					placeholder: "Prioritet",
					1: "Niski",
					2: "Srednji",
					3: "Visoki",
					4: "Kritični"
				}
			},
			dashboardNotifications: {
				title: "Obavijesti",
				allNotificationsLabel: "Sve",
				emptyNotificationsLabel: "Nema novih obavijesti",
				markAllAsReadTooltipText: "Označi sve kao pročitano"
			},
			finaInvoiceCertificates: {
				title: "FINA e-Račun",
				certificateValid: "Certifikat je važeći",
				certificateInvalid: "Certifikat nije važeći"
			}
		},
		dms: {
			title: "DMS",
			documents: {
				title: "Dokumenti",
				documentTitlePlaceholder: "Naziv dokumenta",
				confirmLock: "Jeste li sigurni da želite zaključati dokument?",
				confirmUnlock: "Jeste li sigurni da želite otključati dokument?",
				lockDocumentFailure: "Došlo je do greške prilikom zaključavanja dokumenta",
				lockDocumentSuccess: "Dokument uspješno zaključan",
				unlockDocumentFailure: "Došlo je do greške prilikom otključavanja dokumenta",
				unlockDocumentSuccess: "Dokument uspješno otključan",
				documentsAudit: "Povijest izmjena",
				auditExportFileName: "povijest-izmjena-za-dokument",
				approvals: {
					title: "Odobrenja",
					approveButtonText: "Odobri",
					confirmReviewButtonText: "Potvrdi pregled",
					approvalApprovedMessage: "Dokument odobren!",
					rejectButtonText: "Odbij",
					approvalRejectedMessage: "Dokument odbijen!",
					requestApprovalButtonText: "Zatraži odobrenje",
					requestReviewButtonText: "Zatraži pregled",
					approvalRequestedMessage: "Odobrenje zatraženo",
					reviewRequestedMessage: "Pregled zatražen",
					approvalReason: "Razlog",
					sentApprovalsTitle: "Poslani zahtjevi za odobrenje",
					emptySentApprovalsLabel: "Nema poslanih zahtjeva za odobrenje",
					receivedApprovalsTitle: "Primljeni zahtjevi za odobrenje",
					emptyReceivedApprovalsLabel: "Nema primljenih zahtjeva za odobrenje",
					refreshApprovalsListButtonTooltipText: "Osvježi popis zahtjeva",
					wrongApprovalStatusCondition: "Odobrenje je moguće zatražiti kada je dokument u statusu 'Kreirano', 'Dostupno' ili 'Pregled odobren'",
					wrongReviewStatusCondition: "Pregled je moguće zatražiti kada je dokument u statusu 'Kreiran' ili 'Dostupan'",
					saveChangesFirstConfirmation:
						"Zahtjev će se poslati korisnicima: {{initialUsers}}. Ukoliko ste mijenjali korisnike, molimo spremite promjene prije slanja zahtjeva. Želite li nastaviti?"
				},
				documentLockedChangeStatusTooltipText: "Za promjenu statusa dokumenta, potrebno ga je otključati.",
				changeStatusConfirmation: "Status dokumenta će biti promijenjen u '{{documentStatus}}', želite li nastaviti?",
				changeStatusButtonTextPrefix: "Promijeni status -> ",
				changeStatusSuccessMessage: "Status dokumenta '{{name}}' uspješno promijenjen u '{{newDocumentStatus}}'!",
				statusEnums: {
					0: "Kreiran",
					1: "Dostupan",
					2: "Arhiviran",
					3: "Zatraženo odobrenje",
					4: "Odbijen",
					5: "Odobren"
				},
				createDocumentFromTemplate: {
					toolbarButtonText: "Kreiraj dokument iz predloška",
					rowButtonText: "Kreiraj dokument",
					selectDmsDocTypeTemplateStep: {
						title: "Odabir predloška",
						selectDoctypePlaceholder: "Odaberite tip dokumenta",
						selectTemplatePlaceholder: "Odaberi predložak"
					},
					createDocumentStep: {
						title: "Kreiraj dokument"
					},
					navigateToDocumentStep: {
						title: "Dokument kreiran",
						documentCreatedMessage: "Dokument uspješno kreiran!",
						documentErrorMessage: "Došlo je do greške prilikom kreiranja dokumenta!",
						linkToDocumentButtonText: "Idi na dokument {{documentName}}"
					}
				}
			},
			documentFiles: {
				tabTitle: "Verzije dokumenta",
				restoreFileFailure: "Došlo je do greške prilikom vraćanja verzije dokumenta",
				restoreFileSuccess: "Verzija uspješno vraćena",
				confirmRestoreFile: "Jeste li sigurni da želite vratiti dokument na ovu verziju?",
				previewFile: "Pregledaj",
				editFile: "Uredi",
				saveNewVersion: "Spremi novu verziju",
				saveNewVersionSuccess: "Nova verzija dokumenta uspješno spremljena!",
				replaceWithNewFileSuccess: "Datoteka uspješno zamijenjena!",
				documentLockedEditButtonTooltip: "Za uređivanje dokumenta, potrebno ga je otključati.",
				replaceWithFileToolbarButton: "Zamijeni aktivni dokument",
				replaceWithNewFileButtonText: "Zamijeni s novom datotekom",
				replaceWithExistingFileButtonText: "Zamijeni s postojećom datotekom"
			},
			approvals: {
				confirmStatusChange: "Status pismena će biti promijenjen u '{{pleadingStatus}}', želite li nastaviti?",
				confirmStatusChangeSuccessful: "Status pismena uspješno promijenjen u '{{pleadingStatus}}'!",
				confirmStatusChangeInProgress: "Status pismema će biti promijenjen u 'U obradi', želite li nastaviti?",
				confirmStatusChangeInProgressSuccessful: "Status pismena uspješno promijenjen!"
			}
		},
		archive: {
			title: "Arhiva",
			archiveModal: {
				title: "Arhiviranje",
				tableTitle: "Pregled predmeta za arhiviranje",
				archiveButtonText: "Arhiviraj",
				archiveRecordPlaceholder: "Odaberite arhivsku građu",
				archiveRecordHeader: "Arhivska građa",
				caseTitleHeader: "Naziv predmeta",
				caseClassificationMarkHeader: "Klasifikacijska oznaka",
				legalBasePlaceholder: "Odaberite pravni osnov",
				legalBaseHeader: "Pravni osnov",
				archivedDateHeader: "Datum arhiviranja",
				holdIndefinitelyHeader: "Trajno čuvanje",
				keepUntilHeader: "Čuvati do",
				noCasesSuitableForArchivalMessage: "Nije odabran niti jedan predmet prikladan za arhiviranje",
				noCasesSuitableForArchivalTitle: "Greška prilikom arhiviranja"
			},
			archivedCases: {
				title: "Arhivirani predmeti",
				baseExportFileName: "arhivirani-predmeti"
			},
			archivalEntries: {
				title: "Arhivski zapisi"
			},
			archiveLogEntries: {
				title: "Arhivski zapisi",
				baseExportFileName: "arhivski-zapisi"
			},
			codebooks: {
				title: "Šifrarnik",
				archivalFonds: {
					title: "Fondovi"
				},
				archivalSubFonds: {
					title: "Pod-fondovi"
				},
				archivalSeries: {
					title: "Serije"
				},
				archivalLegalBases: {
					title: "Pravni osnovi"
				},
				archivalRecords: {
					title: "Arhivske građe"
				},
				archivalTechnicalUnits: {
					title: "Tehničke jedinice"
				}
			}
		},
		reports: {
			title: "Izvještaji",
			downloadLink: "Preuzmi izvještaj",
			filter: "Filtriranje",
			registry: {
				title: "Pisarnica",
				registryBook: {
					title: "Urudžbeni zapisnik"
				},
				firstDegreeRegistry: {
					title: "Upisnik predmeta I. stupnja"
				},
				secondDegreeRegistry: {
					title: "Upisnik predmeta II. stupnja"
				},
				documentRegistry: {
					title: "Urudžbeni zapisnik"
				},
				locationDeliveryBookRegistry: {
					title: "Dostavna knjiga za mjesto"
				},
				receivedMailBookRegistry: {
					title: "Knjiga primljene pošte"
				},
				deliveryMailBookRegistry: {
					title: "Knjiga poslane pošte"
				},
				archivalRecordBookRegistry: {
					title: "Knjiga pismohrane"
				},
				nonAdministrativeRegistry: {
					title: "Predmeti neupravnog postupka"
				},
				casesForExtraction: {
					title: "Popis predmeta za izlučivanje"
				},
				caseHandbook: {
					title: "Rokovnik predmeta"
				},
				casesIssuedForInspection: {
					title: "Popis predmeta izdanih na revers"
				}
			},
			dispatch: {
				title: "Otprema",
				postalDeliveryBook: {
					title: "Dostavna knjiga za poštu"
				},
				localDeliveryBook: {
					title: "Dostavna knjiga za mjesto"
				},
				receivedMailBook: {
					title: "Knjiga primljene pošte"
				}
			},
			archive: {
				title: "Arhiva",
				archiveBook: {
					title: "Knjiga pismohrane"
				},
				disposalReadyList: {
					title: "Popis predmeta spremnih za izlučivanje"
				},
				recordsOnLoanList: {
					title: "Popis predmeta izdanih na revers"
				}
			},
			statistics: {
				title: "Statistike",
				casesByStatusAndOrgUnit: {
					title: "Broj predmeta prema statusu riješenosti i nadležnoj ustrojstvenoj jedinici"
				},
				casesByStatusAndDossier: {
					title: "Broj predmeta prema statusu i dosjeu"
				},
				casesByStatusAndAssignee: {
					title: "Broj predmeta po statusu i nadležnom radniku (rješavatelju)",
					workplaceEmployeeFilterPlaceholder: "Rješavatelj nije odabran - svi rješavatelji"
				},
				averageResolutionTimeByCaseType: {
					title: "Prosječno vrijeme rješavanja po vrsti predmeta"
				},
				pleadingsByTypeAndStatus: {
					title: "Broj pismena po tipu (podnesci, akti i interni akti) i statusu "
				},
				transactionsByEmployee: {
					title: "Broj transakcija po radniku (predmeti, pismena, ulazne pošiljke, otpreme)"
				}
			},
			kpi: {
				title: "KPU",
				includeOrgUnit: "Svi iz organizacijske jedinice zaposlenika",
				numberOfDays: "Broj dana",
				configuration: {
					title: "Konfiguracija"
				},
				casesWithoutAssignee: {
					title: "Predmeti bez rješavatelja"
				},
				unacceptedResolutions: {
					title: "Neprihvaćena rješavanja starija od [n] dana"
				},
				pleadingsForSignature: {
					title: "Pismena na potpis/paraf"
				},
				signedPleadingsForDispatch: {
					title: "Potpisana pismena koja čekaju otpremu"
				},
				casesWithExpiredOrSoonDueDeadlines: {
					title: "Predmeti s isteklim ili skorim rokovima"
				},
				averageDeliveryDuration: {
					title: "Prosječan broj dana od slanja do zaprimanja dostave"
				},
				ratioOfCreatedAndResolvedCases: {
					title: "Odnos kreiranih i riješenih predmeta"
				},
				averageResolutionTimePerDossierTypeAndProcess: {
					title: "Prosječno vrijeme rješavanja po dosjeu/vrsti/procesu"
				},
				dynamicsOfSigningAndApproving: {
					title: "Dinamika signiranja i potpisivanja"
				},
				mostCommonProceedingTypeByCaseStatuses: {
					title: "Najčešći procesi po statusima"
				},
				unresolvedCasesByWorkerWithDeadlines: {
					title: "Neriješeni predmeti po radnicima uz prikaz rokova"
				}
			}
		}
	},
	approvals: {
		saveChangesFirstTooltip: "Imate nespremljenih izmjena. Molimo spremite promjene prije slanja zahtjeva.",
		noApproversCondition: "Potrebno je definirati odobravatelje i spremiti promjene prije slanja zahtjeva za odobrenje",
		noReviewersCondition: "Potrebno je definirati pregledavatelje i spremiti promjene prije slanja zahtjeva za pregled",
		notResponsibleEmployeeCondition: "Samo odgovorni zaposlenik može zatražiti odobrenje ili pregled.",
		saveChangesFirstConfirmation:
			"Zahtjev će se poslati korisnicima: {{initialUsers}}. Ukoliko ste mijenjali korisnike, molimo spremite promjene prije slanja zahtjeva. Želite li nastaviti?",
		requestButtonText: {
			"0": "Zatraži odobrenje",
			"1": "Zatraži pregled",
			"2": "Zatraži potpis"
		},
		requestSuccessMessage: {
			"0": "Odobrenje zatraženo",
			"1": "Pregled zatražen",
			"2": "Potpis zatražen"
		}
	},
	import: {
		general: {
			validationErrorsDivider: "Validacijske greške",
			infoDivider: "Dodatne informacije",
			displayImportResultStep: "Status uvoza",
			importStatus: {
				success: "Uvoz podataka uspješno izvršen",
				started: "Uvoz podataka započet",
				validationFailed: "Validacija uvezene datoteke nije uspjela",
				noRowsFoundInImport: "Uvezena datoteka je prazna",
				failed: "Uvoz podataka neuspješan"
			},
			importResultTable: {
				title: "Pregled statusa uvoza podataka",
				importStatusColumn: "Status",
				importedRowsCountColumn: "Broj redaka",
				failureReasonColumn: "Greška"
			},
			importValidationErrorsTable: {
				title: "Pregled validacijskih grešaka",
				rowIndexColumn: "Indeks retka",
				errorsColumn: "Validacijske greške"
			},
			infoTable: {
				title: "Dodatne informacije",
				rowIndexColumn: "Indeks retka",
				infoColumn: "Info"
			},
			errors: {
				somethingWentWrong: "Nešto je pošlo po krivu",
				emptyImportFile: "Molimo uvezite datoteku u ispravnom formatu",
				reviewErrorsAndTryAgain: "Molimo pregledajte validacijske greške, ispravite ih i probajte ponovno"
			}
		},
		classificationPlans: {
			wizardTitle: "Čarobnjak za uvoz klasifikacije",
			importMarksTitle: "Uvezite excel datoteku sa klasifikacijskim oznakama",
			existingPlan: "Postojeći klasifikacijski plan",
			existingPlanPlaceholder: "Unesite naziv klasifikacijskog plana",
			newPlan: "Novi klasifikacijski plan",
			classificationPlanData: "Podaci o klasifikacijskom planu",
			importMarks: "Uvezite klasifikacijske oznake",
			newPlanCreated: "Novi klasifikacijski plan uspješno kreiran"
		},
		workplaceSystematizations: {
			wizardTitle: "Uvoz sistematizacije",
			importSystematizationTitle: "Uvezite excel datoteku",
			displayOrgUnitImportResult: "Org jedinica",
			displayEmployeeImportResult: "Zaposlenici",
			displayWorkplaceImportResult: "Radna mjesta",
			existingSystematizationPlaceholder: "Naziv sistematizacije",
			newSystematization: "Nova sistematizacija",
			existingSystematization: "Postojeća sistematizacija",
			newSystematizationCreated: "Nova sistematizacija uspješno kreirana",
			importSystematizationResultOverview: "Pregled statusa uvoza",
			importFromADSuccess: "Uspješno uvezeno iz Active Directory-a",
			importFromADError: "Greška prilikom uvoza iz Active Directory-a",

			resultOverviewTable: {
				title: "Pregled statusa uvoza",
				stepColumn: "Korak",
				stepStatusColumn: "Status",
				stepStatusMessageColumn: "Poruka",
				importOrgUnitsStep: "Uvoz organizacijskih jedinica",
				importWorkplacesStep: "Uvoz radnih mjesta",
				importEmployeesStep: "Uvoz zaposlenika"
			}
		}
	},
	dataTable: {
		dateFrom: "{{date}} od",
		dateTo: "{{date}} do",
		itemsSelected: "Odrabrano stavki: ",
		createPleadings: "Kreiraj pismena",
		createPleading: "Kreiraj pismeno",
		clearFilters: "Poništi filtere"
	},
	createSelectToggle: {
		existing: "Odaberi postojeće",
		new: "Kreiraj novo"
	},
	wizard: {
		pleadingsFromShipment: {
			title: "Čarobnjak za kreiranje pismena iz pošiljke",
			addShipmentWithPleadings: "Dodaj pošiljku s pismenima",
			shipment: {
				title: "Kreiraj pošiljku",
				optionExisting: "Odaberi postojeću pošiljku",
				optionNew: "Kreiraj novu",
				existingShipmentPlaceholder: "Unesite naziv pošiljke",
				newShipmentCreated: "Pošiljka uspješno kreirana!"
			},
			shipmentFiles: {
				title: "Kreiraj datoteke pošiljke",
				formItemLabel: "Datoteke",
				existingFilesTitle: "Postojeće datoteke",
				newShipmentFilesCreated: "Datoteke uspješno kreirane!"
			},
			case: {
				title: "Odaberi ili kreiraj predmet",
				optionExisting: "Odaberi postojeći predmet",
				optionNew: "Kreiraj novi",
				existingCasePlaceholder: "Unesite naziv predmeta",
				newCaseCreated: "Predmet uspješno kreiran!"
			},
			submission: {
				title: "Kreiraj podneske",
				newSubmissionCreated: "Podnesak uspješno kreiran!"
			},
			submissionFiles: {
				title: "Odaberi priloge podneska",
				selectFiles: "Odaberi priloge iz pošiljke"
			}
		},
		pleadingsFromInvoice: {
			title: "Čarobnjak za kreiranje pismena iz računa",
			addInvoiceWithPleadings: "Dodaj račun s pismenima",
			invoice: {
				title: "Kreiraj račun",
				optionExisting: "Odaberi postojeći račun",
				optionNew: "Kreiraj novi",
				existingInvoicePlaceholder: "Unesite naziv računa",
				newInvoiceCreated: "Račun uspješno kreiran!"
			},
			invoiceFiles: {
				title: "Kreiraj datoteke računa",
				formItemLabel: "Datoteke",
				existingFilesTitle: "Postojeće datoteke",
				newInvoiceFilesCreated: "Datoteke uspješno kreirane!"
			},
			case: {
				title: "Odaberi ili kreiraj predmet",
				optionExisting: "Odaberi postojeći predmet",
				optionNew: "Kreiraj novi",
				existingCasePlaceholder: "Unesite naziv predmeta",
				newCaseCreated: "Predmet uspješno kreiran!"
			},
			submission: {
				title: "Kreiraj podnesak",
				newSubmissionCreated: "Podnesak uspješno kreiran!"
			},
			submissionFiles: {
				title: "Kreiraj priloge podneska",
				selectFiles: "Odaberi priloge iz računa"
			}
		},
		pleadingFromFinaInvoice: {
			title: "Čarobnjak za kreiranje pismena iz e-Računa",
			addFinaInvoiceWithPleadings: "Dodaj e-Račun s pismenima",
			finaInvoice: {
				title: "Odaberi e-Račun",
				optionExisting: "Odaberi postojeći e-Račun",
				optionNew: "Kreiraj novi",
				existingFinaInvoicePlaceholder: "Unesite broj e-Računa",
				newFinaInvoiceCreated: "e-Račun uspješno kreiran!"
			}
		},
		categoryRequestFromShipment: {
			title: "Čarobnjak za kreiranje zahtjeva iz pošiljke",
			shipment: {
				title: "Pošiljka",
				optionExisting: "Odaberi postojeću pošiljku",
				optionNew: "Kreiraj novu",
				existingShipmentPlaceholder: "Unesite naziv pošiljke",
				newShipmentCreated: "Pošiljka uspješno kreirana!"
			},
			shipmentFiles: {
				title: "Datoteke pošiljke",
				formItemLabel: "Datoteke",
				existingFilesTitle: "Postojeće datoteke",
				newShipmentFilesCreated: "Datoteke uspješno kreirane!"
			},
			case: {
				title: "Predmet",
				optionExisting: "Odaberi postojeći predmet",
				optionNew: "Kreiraj novi",
				existingCasePlaceholder: "Unesite naziv predmeta",
				newCaseCreated: "Predmet uspješno kreiran!"
			},
			requestForm: {
				title: "Obrazac",
				existingRequestFormPlaceholder: "Odaberi postojeći obrazac"
			},
			submission: {
				title: "Podnesak",
				optionExisting: "Odaberi postojeći podnesak",
				optionNew: "Kreiraj novi",
				existingSubmissionPlaceholder: "Unesite naziv podneska",
				newSubmissionCreated: "Podnesak uspješno kreiran!"
			},
			submissionFiles: {
				title: "Prilozi podneska",
				selectFiles: "Odaberi priloge iz pošiljke"
			},
			athlete: {
				title: "Podaci sportaša",
				newAthleteCreated: "Sportaš uspješno spremljen!"
			},
			categoryRequest: {
				title: "Zahtjev",
				newRequestCreated: "Zahtjev uspješno kreiran!",
				requestUpdated: "Zahtjev uspješno ažuriran!"
			}
		},
		actFromRequest: {
			title: "Čarobnjak za kreiranje rješenja",
			categoryRequest: {
				title: "Kreiraj ili odaberi zahtjev",
				optionExisting: "Odaberi postojeći zahtjev",
				optionNew: "Kreiraj novi",
				existingRequestPlaceholder: "Unesite naziv zahtjeva",
				newRequestCreated: "Zahtjev uspješno kreiran!",
				requestUpdated: "Zahtjev uspješno ažuriran!"
			},
			submission: {
				title: "Odaberi podnesak",
				existingSubmissionPlaceholder: "Unesite naziv podneska"
			},
			category: {
				title: "Kreiraj ili odaberi kategoriju",
				optionExisting: "Odaberi postojeću kategoriju",
				optionNew: "Kreiraj novu",
				existingCategoryPlaceholder: "Unesite naziv kategorije",
				newCategoryCreated: "Kategorija uspješno kreirana!",
				categoryUpdated: "Kategorija uspješno ažurirana!"
			},
			act: {
				title: "Kreiraj akt",
				newActCreated: "Akt uspješno kreiran!"
			}
		},
		proceedingTypeTransformation: {
			rowButtonText: "Pretvori u upravni postupak",
			pleadingTransformedSuccessfully: "Pismeno uspješno transformirano!",
			createSelectCase: {
				title: "Kreiraj ili odaberi predmet upravne vrste",
				newCaseCreatedMessage: "Upravni predmet uspješno kreiran!",
				optionExisting: "Odaberite postojeći upravni predmet",
				optionNew: "Kreirajte novi upravni predmet",
				existingCasePlaceholder: "Unesite naziv upravnog predmeta"
			},
			createPleading: {
				title: "Kreiraj novo upravno pismeno",
				newPleadingCreated: "Upravno pismeno uspješno kreirano!"
			},
			selectItems: {
				title: "Prebaci priloge pismena",
				selectAllAttachments: "Odaberi sve priloge",
				selectAllNotes: "Odaberi sve bilješke"
			},
			cancelPleadingAndCase: {
				title: "Storniraj pismeno i predmet",
				cancelingSuccessful: "Storniranje uspješno!",
				cancelCase: "Storniraj predmet '{{value}}'",
				cancelCaseSuccessful: "Predmet uspješno!",
				cancelPleading: "Storniraj pismeno '{{value}}'",
				cancelPleadingSuccessful: "Pismeno uspješno stornirano!"
			}
		},
		nextStep: "Sljedeće",
		previousStep: "Prethodno"
	},
	imageGallery: {
		room: "Prostorija",
		selectRoom: "Odaberite prostoriju",
		searchRooms: "Pretraži po prostorijama",
		noAssignedRoomSearch: "Pretraži bez dodijeljene prostorije"
	},
	validations: {
		invalidPassportExpiryDate: "Neispravna godina isteka!",
		invalidCardNumber: "Unos mora sadržavati točno 9 znamenki!",
		valueNaN: "Vrijednost mora biti broj!",
		fieldRequired: "Polje je obavezno!",
		enterPossibleValues: "Unesite moguće vrijednosti",
		minLengthWithValue: "Minimalna dužina je {{value}}!",
		maxLengthWithValue: "Maksimalna dužina je {{value}}!",
		maxCharLengthOf255: "Maksimalna dužina je 255 znakova!",
		enterDefaultValue: "Unesite zadanu vrijednost",
		valueGTE: "Vrijednost mora biti veća od ili jednaka {{value}}!",
		valueLTE: "Vrijednost mora biti manja od ili jednaka {{value}}!",
		valueNotInRange: "Vrijednost mora biti između {{min}} i {{max}}",
		minGTMax: "Minimalna mora biti manja od maksimalne vrijednosti!!",
		valueAlreadyExists: "Vrijednost već postoji!",
		singleValue: "Samo jedan zapis može biti postavljen!",
		emptySubjectOrBody: "Naslov ili tijelo poruke moraju biti popunjeni!",
		incorrectEmailFormat: "Email nije u ispravnom formatu!",
		incorrectPhoneNumberFormat: "Tel. broj nije u ispravnom formatu!",
		incorrectOIBFormat: "OIB nije u ispravnom formatu!",
		usernameAndPasswordOverrideBothRequired: "Korisničko ime i lozinka su obavezni ako je jedno od njih uneseno!",
		atLeastOneIdFieldRequired: "Minimalno jedan oblik identifikacije mora biti popunjen!",
		exactLengthWithValue: `Polje mora sadržavati točno {{value}} znakova!`
	},
	userAccess: {
		tabTitle: "Prava pristupa",
		readAccess: "Čitanje",
		writeAccess: "Pisanje",
		deleteAccess: "Brisanje",
		importAccess: "Uvoz",
		accessType: "Vrsta pristupa",
		grantAccess: "Omogući pristup",
		revokeAccess: "Opozovi pristup",
		manageAccesses: "Upravljaj pristupima",
		forPeriod: "Na period",
		reason: "Razlog"
	},
	errors: {
		refreshPage: "Osvježite stranicu ili pokušajte ponovno kasnije.",
		pageNotExists: "Stranica koju ste posjetili ne postoji",
		unauthorizedTitle: "Nedopušten pristup stranici!",
		unauthorizedSubTitle: "Nemate dovoljnu razinu prava za pregledavanje stranice, obratite se administratoru",
		backToHomepage: "Natrag na početnu stranicu",
		toHomepage: "Na početnu",
		unknownError: "Nepoznata greška",
		somethingWentWrong: "Nešto je pošlo po krivu",
		networkError: {
			title: "Poteškoće s mrežom",
			detail: "Provjerite ispravnost internetske konekcije"
		},
		errorCode: "Kod greške",
		errorCodeEnumMessages: {
			"1": "Samo jedno zadano radno mjesto po korisniku.",
			"2": "Za kreiranje podneska potreban je prijavljeni djelatnik.",
			"3": "Za ažuriranje podneska potreban je prijavljeni djelatnik.",
			"4": "Za kreiranje predmeta potreban je prijavljeni djelatnik.",
			"5": "Za ažuriranje predmeta potreban je prijavljeni djelatnik.",
			"6": "Validacija ulaznih parametara radnog procesa nije uspjela.",
			"7": "Validacija izlaznih parametara prethodnog koraka radnog procesa nije uspjela.",
			"8": "Korisnik mora biti dodijeljen podnesku kako bi zatražio odobrenje.",
			"9": "Odobrenje može zatražiti samo korisnik koji je dodijeljen.",
			"10": "Nevažeći prijelaz stanja podneska.",
			"11": "Možete odobriti ili odbiti samo vlastite zahtjeve za odobrenje.",

			// Email attachment download link error codes
			"100": "Poveznica za preuzimanje nije pronađena.",
			"101": "Poveznica za preuzimanje je već iskorištena.",
			"102": "Poveznica za preuzimanje je istekla.",
			"103": "Nema privitaka za preuzimanje.",

			// Croatian Olympic Committee
			"300": "Obrazac zahtjeva za kategoriju je u uporabi.",

			// Identity error codes
			"1000": "Korisničko ime već postoji.",

			// Import error codes
			"2000": "Iznajmljivač je obavezan u postupku uvoza.",

			// DMS error codes
			"3000": "Za kreiranje dokumenta potreban je prijavljeni djelatnik.",
			"3001": "Za ažuriranje dokumenta potreban je prijavljeni djelatnik.",
			"3002": "Ažuriranje zaključanog dokumenta nije dopušteno.",
			"3003": "Za zaključavanje dokumenta potreban je prijavljeni djelatnik.",
			"3004": "Za otključavanje dokumenta potreban je prijavljeni djelatnik.",
			"3005": "Korisnik mora biti dodijeljen dokumentu kako bi zatražio odobrenje.",
			"3006": "Nevažeći prijelaz stanja dokumenta.",

			// ePK error codes
			"4000": "Došlo je do pogreške prilikom generiranja ePK datoteke."
		},
		http: {
			400: {
				title: "Nepotpun zahtjev",
				detail: "Nevažeć ili nepotpun zahtjev. Provjerite zadane vrijednosti."
			},
			401: {
				title: "Neovlašten pristup",
				detail: "Provjera autentičnosti nije uspjela. Provjerite imate li ispravne pristupne podatke"
			},
			403: {
				title: "Pristup zabranjen",
				detail: "Nemate dopuštenje za pregled ovog sadržaja"
			},
			404: {
				title: "Nije pronađeno",
				detail: "Tražena stranica ili resurs ne postoji. Provjerite ispravnost adrese"
			},
			408: {
				title: "Istek zahtjeva",
				detail: "Vrijeme zahtjeva isteklo. Provjerite internetsku povezanost"
			},
			409: {
				title: "Konflikt prilikom uređivanja",
				detail: "Netko drugi je u međuvremenu uredio zapis. Osvježite prozor i probajte ponovno."
			},
			429: {
				title: "Previše zahtjeva",
				detail: "Smanjite broj uzastopnih zahtjeva i pokušajte kasnije"
			},
			500: {
				title: "Interna greška poslužitelja",
				detail: "Interna greška poslužitelja. Poslužitelj je naišao na problem"
			},
			502: {
				title: "Nevažeć pristupni poslužitelj",
				detail: "Postoji problem s uzvodnim zahtjetvom"
			},
			503: {
				title: "Usluga nedostupna",
				detail: "Poslužitelj je trenutno u ispadu"
			},
			504: {
				title: "Istek zahtjeva pristupnog",
				detail: "Odgovor od poslužitelja traje predugno"
			}
		},
		formValidations: {
			requiredFields: {
				title: "Nepotpuna forma",
				description: "Popuniti potrebna polja"
			}
		}
	},
	common: {
		yes: "Da",
		no: "Ne",
		minimal: "Minimalna",
		maximal: "Maksimalna",
		active: "Aktivan",
		preferred: "Preferirano",
		save: "Spremi",
		saveAndContinue: "Spremi i nastavi",
		saveAndFinish: "Spremi i završi",
		back: "Natrag",
		cancel: "Odustani",
		close: "Zatvori",
		change: "Promijeni",
		finish: "Završi",
		submit: "Podnesi",
		show: "Prikaži",
		showFile: "Prikaži datoteku",
		showAsPdf: "Prikaži kao PDF",
		edit: "Uredi",
		delete: "Obriši",
		clear: "Odznači",
		adding: "Dodavanje",
		editing: "Uređivanje",
		search: "Pretraživanje",
		searchWithValue: "Pretraživanje {{value}}",
		searchAll: "Pretraži sve",
		add: "Dodaj",
		confirm: "Potvrdi",
		remove: "Ukloni",
		load: "Učitaj",
		export: "Izvoz",
		exportGrid: "Izvoz tablice",
		noDataForExportMessage: "Nema podataka za izvoz.",
		noDataForExportDetail: "Odabrani filteri su rezultirali sa praznom datotekom. Promijenite filtere i pokušajte ponovno.",
		loading: "Učitavanje..",
		download: "Preuzmi",
		downloadAsArchive: "Preuzmi kao arhivu",
		refresh: "Osvježi",
		disabled: "Onemogućeno",
		created: "Stvoreno",
		modified: "Izmijenjeno",
		replace: "Zamijeni",
		start: "Početak",
		end: "Kraj",
		name: "Ime",
		title: "Naziv",
		type: "Vrsta",
		ofPleading: "Pismena",
		date: "Datum",
		month: "Mjesec",
		forPeriod: "Za period",
		createdDate: "Datum kreiranja",
		modifiedDate: "Datum zadnje izmjene",
		time: "Vrijeme",
		dateAndTime: "Datum i vrijeme",
		description: "Opis",
		details: "Detalji",
		default: "Zadano",
		errorOccurred: "Došlo je do greške!",
		errorChangesNotSaved: "Promjene nisu spremljene!",
		changesSavedSuccess: "Promjene uspješno spremljene!",
		deleteSuccess: "Brisanje uspješno!",
		deleteError: "Došlo je do greške, brisanje neuspješno!",
		deleteItemQuestion: "Jeste li sigurni da želite obrisati stavku?",
		deleteItemsQuestion: "Jeste li sigurni da želite obrisati stavke?",
		generalData: "Osnovni podaci",
		instructions: "Upute",
		discardChanges: "Jeste li sigurni da želite odbaciti izmjene?",
		valueFrom: "{{value}} od",
		valueTo: "{{value}} do",
		attachments: "Prilozi",
		activate: "Aktiviraj",
		deactivate: "Deaktiviraj",
		validFrom: "Vrijedi od",
		validTill: "Vrijedi do",
		enable: "Uključi",
		disable: "Isključi",
		copy: "Kopiraj",
		paste: "Zalijepi",
		setAsDefault: "Postavi kao zadano",
		setAsDefaultSuccess: "Zapis uspješno postavljen kao zadan",
		setAsDefaultError: "Došlo je do greške, zapis nije postavljen kao zadan",
		document: "Dokument",
		exportSuccess: "Izvoz uspješan!",
		exportError: "Došlo je do greške prilikom izvoza!",
		exportBaseFileName: "IzvozTablice",
		exportConfirmationText: "Jeste li sigurni da želite izvesti podatke s primijenjenim filtriranjem?",
		createFileError: "Došlo je do greške prilikom kreiranja datoteke",
		reports: "Izvještaji",
		additionalData: "Dodatni podaci",
		importFromExcel: "Uvoz iz Excela",
		importFromAD: "Uvoz iz Active Directory-a",
		excelFile: "Excel datoteka",
		system: "Sustav",
		uploadFile: "Učitajte datoteku",
		fileName: "Naziv datoteke",
		version: "Verzija",
		isActive: "Aktivan",
		lock: "Zaključaj",
		unlock: "Otključaj",
		set: "Postavi",
		restore: "Postavi kao aktivnu verziju",
		filterBy: "Filtriraj po",
		byYear: "Po godini",
		datePeriod: "Periodu datuma",
		dateFrom: "Datum od",
		dateTo: "Datum do",
		format: "Format",
		class: "Klasa",
		selectClass: "Odaberi klasu",
		organizationalUnit: "Organizacijska jedinica",
		selectOrganizationalUnit: "Odaberi organizacijsku jedinicu",
		employee: "Zaposlenik",
		selectEmployee: "Odaberi zaposlenika",
		caseStatus: "Status predmeta",
		selectCaseStatus: "Odaberi status predmeta",
		dossier: "Dosje",
		selectDossier: "Odaberi dosje",
		pleadingStatus: "Status pismena",
		selectPleadingStatus: "Odaberi status pismena",
		proceedingType: "Vrsta postupka",
		selectProceedingType: "Odaberi vrstu postupka",
		pleadingType: "Vrsta pismena",
		selectPleadingType: "Odaberi vrstu pismena"
	},
	authButton: {
		impersonation: {
			employeePlaceholder: "Zaposlenik",
			branchOfficePlaceholder: "Poslovnica"
		}
	},
	fileViewer: {
		pdfViewerError: "Pogreška prilikom učitavanja PDF-a. Datoteka je možda oštećena ili ne postoji!"
	},
	signatures: {
		signaturePanel: {
			title: "Panel za potpis",
			signButton: "Potpiši",
			tabs: {
				usbToken: "Potpiši USB tokenom",
				draw: "Nacrtaj potpis",
				upload: "Učitaj potpisani dokument"
			},
			messages: {
				documentSignedSuccess: "Dokument uspješno potpisan USB tokenom",
				signatureError: "Greška prilikom spremanja potpisa",
				signatureSaved: "Potpis uspješno spremljen",
				documentSavedAsAttachment: "Potpisani dokument uspješno spremljen kao privitak",
				documentSaved: "Potpisani dokument uspješno spremljen",
				noFileSelected: "Nije odabrana datoteka",
				documentSaveError: "Greška prilikom spremanja dokumenta",
				selectDocumentForSigning: "Molimo odaberite dokument za potpisivanje",
				selectDocumentForUsbSigning: "Molimo odaberite dokument za potpisivanje USB tokenom"
			},
			upload: {
				dragText: "Kliknite ili povucite datoteku u ovo područje",
				hint: "Podržane su PDF ili slikovne datoteke",
				cancel: "Odustani",
				save: "Spremi",
				fileTypeError: "Možete učitati samo PDF ili slikovne datoteke!"
			}
		},
		validation: {
			title: "Validacija digitalnih potpisa",
			validateSignatures: "Validiraj potpise",
			validating: "Validacija potpisa u tijeku...",
			validationError: "Greška prilikom validacije potpisa",
			noAttachmentsSelected: "Nije odabran nijedan prilog",
			valid: "Važeći",
			invalid: "Nevažeći",
			unknownSigner: "Nepoznati potpisnik",
			documentName: "Dokument: {{name}}",
			overallStatus: "Ukupni status",
			documentHash: "Hash dokumenta",
			validationTimestamp: "Vrijeme validacije",
			signaturesCount: "Broj potpisa",
			validationErrors: "Greške validacije",
			signaturesDetails: "Detalji potpisa",
			signerName: "Ime potpisnika",
			signerEmail: "Email potpisnika",
			signedDate: "Datum potpisivanja",
			signatureReason: "Razlog potpisivanja",
			signatureLocation: "Lokacija potpisivanja",
			contactInfo: "Kontakt informacije",
			signatureStatus: "Status potpisa",
			signatureValid: "Potpis važeći",
			certificateValid: "Certifikat važeći",
			validationMessages: "Poruke validacije",
			certificateDetails: "Detalji certifikata",
			certificate: {
				subject: "Subjekt",
				issuer: "Izdavatelj",
				serialNumber: "Serijski broj",
				certificateType: "Tip certifikata",
				trustLevel: "Razina povjerenja",
				qualificationLevel: "Razina kvalifikacije",
				validFrom: "Važeći od",
				validTo: "Važeći do",
				thumbprint: "Otisak",
				keyAlgorithm: "Algoritam ključa",
				signatureAlgorithm: "Algoritam potpisa",
				version: "Verzija",
				status: "Status certifikata",
				expired: "Istekao",
				notYetValid: "Još nije važeći",
				valid: "Važeći",
				keyUsages: "Upotreba ključa",
				enhancedKeyUsages: "Proširena upotreba ključa",
				types: {
					Unknown: "Nepoznato",
					SelfSigned: "Samopotpisan",
					DomainValidated: "Validiran domenom",
					OrganizationValidated: "Validiran organizacijom",
					ExtendedValidation: "Proširena validacija",
					CodeSigning: "Potpisivanje koda",
					TimeStamping: "Vremenska oznaka",
					EmailSigning: "Potpisivanje e-pošte",
					DocumentSigning: "Potpisivanje dokumenata",
					Qualified: "Kvalificirani",
					QualifiedWebsiteAuthentication: "Kvalificirana web autentifikacija",
					QualifiedSeal: "Kvalificirani pečat"
				},
				trustLevels: {
					Unknown: "Nepoznato",
					Untrusted: "Nepouzdan",
					SelfSigned: "Samopotpisan",
					Trusted: "Pouzdan",
					HighlyTrusted: "Visoko pouzdan",
					GovernmentTrusted: "Državno pouzdan"
				},
				qualificationLevels: {
					Unknown: "Nepoznato",
					Basic: "Osnovni",
					Advanced: "Napredni",
					Qualified: "Kvalificirani",
					AdvancedWithQSCD: "Napredni s QSCD",
					QualifiedWithQSCD: "Kvalificirani s QSCD"
				}
			}
		},
		usbTokenSigning: {
			title: "Potpisivanje USB tokenom",
			certificateDetection: {
				title: "Otkrivanje certifikata",
				detectButton: "Otkrij USB token",
				refreshButton: "Osvježi",
				detectingMessage: "Otkrivanje USB tokena i učitavanje certifikata...",
				availableCertificates: "Dostupni certifikati:",
				noDigitalIds: "Nisu pronađeni digitalni identiteti. Molimo umetnite USB token ili instalirajte digitalni identitet.",
				certificatesFound: "Pronađeno {{count}} hardverski podržanih certifikata",
				certificateSelected: "Odabran certifikat: {{name}}. Driver će zatražiti PIN prilikom potpisivanja.",
				selectCertificateFirst: "Molimo prvo odaberite certifikat"
			},
			signing: {
				generatingHash: "Generiranje hash-a dokumenta...",
				signingMessage: "Potpisivanje hash-a USB tokenom... Driver može zatražiti PIN.",
				invalidHashFormat: "Nevažeći format hash-a primljen od servera",
				hashLengthMismatch: "Nepodudaranje duljine hash-a: Očekivano {expected} znakova za {algorithm}, dobiveno {actual}. Izvorni format: {format}",
				signDocumentButton: "Potpiši dokument",
				signingDocumentInProgress: "Potpisivanje..."
			},
			documentHash: {
				hexadecimal: "Heksadecimalni",
				base64Conversion: "Base64 (bit će pretvoreno u hex)"
			},
			certificates: {
				usbTokenLabel: "(USB Token certifikat)",
				issuedBy: "Izdao:",
				expires: "Istječe:",
				subject: "Subjekt:",
				issuer: "Izdavatelj:",
				validFrom: "Važeći od:",
				validTo: "Važeći do:",
				serialNumber: "Serijski broj:",
				thumbprint: "Otisak:",
				hasPrivateKey: "Ima privatni ključ:",
				hardwareBacked: "Hardverski podržan:",
				yes: "Da",
				no: "Ne"
			},
			cades: {
				successMessage: "CAdES potpis uspješno završen!",
				signatureFormat: "Format potpisa:",
				algorithm: "Algoritam:",
				signingTime: "Vrijeme potpisivanja:",
				certificateChain: "Lanac certifikata:",
				certificates: "certifikat(a)",
				message: "Poruka:",
				completedMessage: "CAdES potpis završen: {message}"
			},
			errors: {
				error: "Greška:",
				unknownError: "Nepoznata greška",
				signingDocument: "Greška pri potpisivanju dokumenta:"
			}
		}
	}
};

export default hr;
